// extracted by mini-css-extract-plugin
var _1 = "_K9Yi";
var _2 = "InlZp";
export { _1 as "base", _2 as "pane" }
